import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export const UrgencySection = () => {
  return <section className="py-20 bg-sage border-y border-sage-dark" data-id="element-437">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-438">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-439">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white text-brand-600 mb-6 shadow-sm" data-id="element-440">
            <AlertTriangle className="w-8 h-8" data-id="element-441" />
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-8" data-id="element-442">
            Precio de Lanzamiento — Tiempo Limitado
          </h2>

          <div className="space-y-6 text-lg text-neutral-800" data-id="element-443">
            <p data-id="element-444">CAJA DE COBRO está en precio de lanzamiento.</p>
            <p className="text-2xl font-bold text-neutral-900" data-id="element-445">
              Después del período inicial, el precio sube a{' '}
              <span className="text-brand-700 line-through decoration-brand-600/50" data-id="element-446">
                $34.990 ARS
              </span>
              .
            </p>
            <p data-id="element-447">No es una táctica de marketing vacía.</p>
            <p data-id="element-448">
              Es simple: este es el primer lanzamiento y queremos que las
              primeras personas que confíen en el sistema tengan el mejor precio
              posible.
            </p>
            <p data-id="element-449">
              Una vez que tengamos los primeros 100 testimonios documentados, el
              precio refleja el valor real del bundle completo.
            </p>

            <div className="mt-12 p-6 bg-white rounded-xl border border-sage-dark shadow-sm" data-id="element-450">
              <p className="font-bold text-neutral-900 text-xl mb-2" data-id="element-451">
                Si llegaste hasta acá, ya sabés que lo necesitás.
              </p>
              <p className="text-brand-700" data-id="element-452">
                La única pregunta es si lo vas a hacer hoy o en 30 días más,
                después de otro mes sin el sistema.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};